import React, { useState, useEffect, createContext, useContext, useCallback } from "react";
import axios from "axios";
import { API } from "../config";
import { useAuth } from "./AuthContext";

const WishlistContext = createContext(null);

export const WishlistProvider = ({ children }) => {
  const { token } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const ids = items.map((p) => p.id);

  const fetchWishlist = useCallback(async () => {
    if (!token) {
      setItems([]);
      return;
    }
    try {
      const res = await axios.get(`${API}/wishlist`);
      setItems(res.data?.items || []);
    } catch (err) {
      console.error("Failed to fetch wishlist:", err);
    }
  }, [token]);

  useEffect(() => {
    fetchWishlist();
  }, [fetchWishlist]);

  const isSaved = (productId) => ids.includes(productId);

  const toggleSaved = async (productId) => {
    if (!token) return { ok: false, requiresAuth: true };
    setLoading(true);
    try {
      if (isSaved(productId)) {
        await axios.delete(`${API}/wishlist/${productId}`);
        setItems((prev) => prev.filter((p) => p.id !== productId));
        return { ok: true, saved: false };
      }
      await axios.post(`${API}/wishlist/add`, { product_id: productId });
      await fetchWishlist();
      return { ok: true, saved: true };
    } catch (err) {
      console.error("Failed to toggle wishlist:", err);
      return { ok: false };
    } finally {
      setLoading(false);
    }
  };

  return (
    <WishlistContext.Provider
      value={{ items, ids, loading, isSaved, toggleSaved, fetchWishlist }}
    >
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);
